import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { areaShort } from '../data/planUi.ts'
import type { AreaRow } from '../data/geo.ts'
import { useLocationOn } from '../data/location.ts'
import { Picto } from './pictos.tsx'

/** A job's areas, each with its way on the map and a "Me guider" (M19): the guidance uses this phone's position on screen only, it shares nothing.
 *  `guide` is false on a workstation (a screen in the shed has nowhere to walk to). An area in `done` (covered in full by an earlier finish of the job)
 *  keeps its place in the list, without the guidance: there is nowhere left to go for it. Where the club has location off (M21), the same button is
 *  "Voir sur la carte": the guide page then shows the area on the map, and never asks for the phone's position. */
export function AreaGuideList({ ids, areaById, lang, guide, done, testId }: { ids: string[]; areaById: Map<string, AreaRow>; lang: string; guide: boolean; done?: ReadonlySet<string>; testId: string }) {
  const { t } = useTranslation()
  const location = useLocationOn()
  return (
    <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2" data-testid={testId}>
      {ids.map((id) => (
        <li key={id} className="flex items-stretch gap-2" data-area={id} data-done={done?.has(id) ? '1' : undefined}>
          <Link to="/map" search={{ area: id }} className="flex min-h-14 min-w-0 flex-1 items-center rounded-xl border-2 border-slate-300 bg-white px-3 py-2 text-sm font-medium active:bg-fairway-light dark:border-slate-600 dark:bg-night-card dark:active:bg-night">
            <span className="truncate">{areaShort(areaById.get(id), areaById, lang, t)}</span>
          </Link>
          {guide && !done?.has(id) && (
            <Link to="/map/guide" search={{ area: id }} className="btn shrink-0 !px-3" data-testid="guide-go" data-area={id} data-mode={location ? 'guide' : 'view'}>
              <Picto name="map" className="size-5" />{location ? t('guide.go') : t('guide.view')}
            </Link>
          )}
        </li>
      ))}
    </ul>
  )
}
